<template>
  <div v-if="isButtonVisible">
    <button class="btn btn-hover btn-cart" :class="added ? 'btn-primary' : data.class"
      @click.prevent="addToCartWishList" :disabled="isDisabled">{{ buttonlabel }}</button>
    <div class="modal-cart" v-show="showModal">
      <div v-if="isDisabled">
        <h4>{{ label_adding_to_cart }}</h4>
      </div>
      <div v-if="!isDisabled">
        <h4>{{ label_added_to_cart }}</h4>

        <a :href="netsuite_url + 'cart'" target="_blank"
           class="btn btn-hover btn-primary btn-cart" @click="showModal = false"
        >{{ label_view_cart }}</a>

        <a class="close btn btn-hover btn-primary btn-wishlist" @click.prevent="showModal = false">{{
            label_continue_shopping
        }}</a>
      </div>
    </div>
    <div class="modal-bg" v-show="showModal"></div>
  </div>
</template>

<script>
import { getCartUrl } from "../../store/modules/helpers";
import addToCartMixin from "../../mixins/addToCartMixin";
import { getRegionConfig } from "../../utils/regionConfig";
import { buildNetSuiteStockUrl, buildNetSuiteChildComponentsUrl } from "../../utils/netsuiteUrlBuilder";

export default {
  name: "add-to-cart-parent",
  mixins: [addToCartMixin],
  props: {
    data: {},
    netsuite_app_url: {
      type: String
    },
    sitekey:{
      type: String
    },
    netsuite_url: {
      type: String
    },
    netsuite_parent_id :{
      type: String,
    },
    netsuite_id: {
      type: String
    },
    package_components: {
      type: String
    },
    parent_status: {
      type: String
    },
    parent_isinstock: {
      type: String
    },
    parent_isbackorderable: {
      type: String
    },
    childactivestatus: {
      type: String
    },
    childbackorderablestatus: {
      type: String
    },
    product_id: {
      type: String
    },
    components: {
      type: Array
    },
    is_stock_waitlist_active: {
      type: String
    },
    is_spare_part_enabled: {
      type: String
    },
    item_id: {
      type: String,
    },
    item_name: {
      type: String,
    },
    item_brand: {
      type: String,
      default: "Rhinorack"
    },
    item_category: {
      type: String,
    },
    price: {
      type: Number,
    },
    label_added_to_cart: {
      type: String,
      default: "Added to Cart"
    },
    label_add_to_cart: {
      type: String,
      default: "Add to Cart"
    },
    label_adding_to_cart: {
      type: String,
      default: "Adding to Cart"
    },
    label_view_cart: {
      type: String,
      default: "View Cart"
    },
    label_continue_shopping: {
      type: String,
      default: "Continue Shopping"
    },
    is_always_in_stock: {
      type: String,
      default: "0"
    },
    ga_tracking_category: {
      type: String,
      default: "add_to_cart"
    }
  },
  data() {
    return {
      cartmode: false,
      isDisabled: false,
      added: false,
      item: null,
      currency: window.currency,
      showModal: false,
      ns_session_var: window.ns_session_var,
      tax: window.tax,
      culture: window.culture,
      country: window.country,
      availabilityAU: null,
      userType: 'B2C',
    };
  },
  mounted() {
    this.applyStockConditions();
    this.fetchProductDetails();
    this.isB2bUser();
  },
  computed: {
    locId() {
      return getRegionConfig(window.culture).locId;
    },
    regionId() {
      return getRegionConfig(window.culture).regionId;
    },
  },
  methods: {
    async addToCartWishList() {
      this.showModal = true;

      const item_stockcode = this.components && this.components.length === 0 
        ? this.data.stockCode 
        : this.data.stockCode + 'N';

      // Google Analytics tracking
      if (typeof gtag === 'function') {
        gtag('event', this.ga_tracking_category || 'add_to_cart', {
          currency: this.currency,
          value: this.price,
          items: [
            {
              item_id: item_stockcode,
              item_name: this.item_name,
              item_brand: this.item_brand || 'Rhinorack',
              item_category: this.item_category,
              price: this.price
            }
          ]
        });
      }

      try {
        const cartItems = await this.getPackageComponents();
        this.addItemTocart(cartItems);
      } catch (error) {
        // Error already handled in getPackageComponents
        this.showModal = false;
      }
    },
    async fetchProductDetails() {
      const apiData = await axios.get(this.cartUrl, { withCredentials: true });
      this.$store.commit('cart/setApiData', apiData.data);
    },
    applyStockConditions() {
      this.$store.commit('cart/setNetsuiteId', this.data.netSuiteId);
      this.$store.commit('cart/setStockCode', this.data.stockCode);
      this.$store.commit('cart/checkPackageWithoutComponents', this.is_always_in_stock);
    },
    isB2bUser() {
      this.userType = this.$store.getters["auth/userType"]; 
    },
  },
  computed: {
    isButtonVisible() {
      if (this.data.packagecomponents == 1) {
        return false;
      }
      return this.$store.getters['cart/isAddToCartButtonVisible']();
    },
    cartUrl() {
      return getCartUrl(this.netsuite_url, this.netsuite_id, this.components);
    },
    cartUrlParams() {
      return this.$store.getters["cart/getCartUrlParams"] ?? '';
    }
  },
  
};
</script>

<style>
.modal-cart {
  background: #fff;
  width: 300px;
  height: auto;
  text-align: center;
  position: fixed;
  top: 50%;
  margin-top: -50px;
  left: 50%;
  margin-left: -100px;
  line-height: 25px;
  z-index: 100001;
  padding: 15px;
}

.modal-cart .close,
.modal-cart .close:hover {
  cursor: pointer;
}

.modal-bg {
  background-color: rgba(0, 0, 0, 0.2);
  opacity: 0.2;
  filter: alpha(opacity=20);
  zoom: 1;

  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100000;
}
</style>
